import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../../model/widget.model';

@Component({
    selector: 'app-crm-calendar-widget-settings',
    templateUrl: './crm-calendar-widget.settings.component.html',
    styleUrl: './crm-calendar-widget.settings.component.scss'
})
export class AppCRMCalendarWidgetSettingsComponent {
    @Input() widget: WidgetModel;
}